import { requestTool } from "../tools";

const CONTROLLER_URL = "/api/user/";

const get = (username) => requestTool.
    getRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL + username);

const add = (item) => requestTool.
    postRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL, item);

const update = (item) => requestTool.
    putRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL, item);

export const userService = { add, get, update };

export default userService;

